// frontend/src/components/LoanSection.jsx
import "./LoanSection.css";

export default function LoanSection({ loans, projectName }) {
  if (!loans?.length) return null;

  const bankNames = loans.map((l) => l.bank_name).filter(Boolean);

  return (
    <section className="loan-section section" aria-labelledby="loan-heading">
      <div className="container loan-section__inner">
        <h2 id="loan-heading" className="section-heading">
          Our Loan &amp; Banking <span className="loan-section__accent">Partners</span>
        </h2>
        <h3 className="loan-section__sub">
          Home Loan Available for {projectName}
        </h3>

        <div className="loan-logos">
          {loans.map((bank, i) => (
            <figure key={i} className="loan-logo">
              <img
                src={bank.logo_url}
                alt={bank.alt_text || bank.bank_name}
                loading="lazy"
              />
            </figure>
          ))}
        </div>

        {bankNames.length > 0 && (
          <p className="loan-section__more">
            {bankNames.join(", ")} and more banks
          </p>
        )}
      </div>
    </section>
  );
}
